import React, { useState } from "react";

import { motion } from "framer-motion/dist/framer-motion";
import OutsideClickHandler from "react-outside-click-handler";

import { ReactComponent as Sparkle } from "../../../assets/images/common/Sparkle.svg";
import "./RandomizerButton.css";

const RandomizerButton = ({ onOptionClick }) => {
//   const [isOpen, setIsOpen] = useState(false);
  const [hoveredOption, setHoveredOption] = useState(null);

  //   const handleMouseOver = () => setIsOpen(true);
  const handleMouseLeave = () => setHoveredOption(null);
  const handleOutsideClick = () => {
    // setIsOpen(false);
    setHoveredOption(null);
  };

  const handleOptionClick = () => {
    // if (option === "share") setShareSubmission(true);
    // if (option === "create") setCreateSubmission(true);
    // setIsOpen(false);
    onOptionClick();
    setHoveredOption(null);
  };

  const handleOptionHover = (option) => setHoveredOption(option);

  const options = [
    { icon: <Sparkle width={18} height={18} title="tube icon" />, text: "Smart Randomizer", option: "create" },
  ];

  const renderOption = ({ text, option, icon }) => {
    const isHovered = hoveredOption === option;
    const baseClassName = icon ? "RandomizerButton__Option" : "RandomizerButton";
    const hoverClassName = icon ? "RandomizerButton__Option--hover" : "RandomizerButton__Option_Create--hover";
    const className = `${baseClassName} ${isHovered ? hoverClassName : ""}`;

    return (
      <motion.div
        key={option}
        className={className}
        onMouseOver={() => handleOptionHover(option)}
        onFocus={() => handleOptionHover(option)}
        onMouseLeave={handleMouseLeave}
        onBlur={handleMouseLeave}
        onClick={() => handleOptionClick()}
        layout
        transition={{ duration: icon ? 0.20 : 0.10, ease: "easeOut" }}
      >
        {isHovered && <span>{text}</span>}
        {icon || <Sparkle width={24} height={24} title="add icon" />}
      </motion.div>
    );
  };

  return (
    <OutsideClickHandler onOutsideClick={handleOutsideClick}>
      {renderOption({ text: options[0].text, option: options[0].option })}
    </OutsideClickHandler>
  );
};

export default RandomizerButton;
